/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var moyaToggle = MoyaContainer.get('core.toggle');
    MoyaComponents.register('site.dropdown', function (el) {
        moyaToggle.create(el.querySelector('button'), el.querySelector('.content'), 'qnDropdown', {
            onOpen: function () {
                document.body.classList.remove('dropdown-open');
                document.querySelector('#mainmenu .level1.open').classList.remove('open');
            }
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
